import { render, staticRenderFns } from "./hgs-detail.vue?vue&type=template&id=08ea5539"
import script from "./hgs-detail.vue?vue&type=script&lang=js"
export * from "./hgs-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports